import React from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router-dom'
import {checkIsActive, WithChildren} from '../../../../helpers'

type Props = {
  to: string
  title: string
  fontIcon?: string
  hasBullet?: boolean
  badge?: React.ReactNode
}

const tutorial: {[key: string]: string} = {
  'Equipes & Pessoas': 'equipes-e-pessoas',
  Relatórios: 'relatorios',
  Projetos: 'projetos',
  Sprints: 'sprints',
  Cronogramas: 'cronogramas',
  'Time Tracking': 'timetracking',
  Clientes: 'clientes',
  Contratos: 'contratos',
  Wiki: 'wiki',
}

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  fontIcon,
  hasBullet,
  badge,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)

  return (
    <div
      className={clsx('menu-item', {'here show': isActive}, 'menu-accordion')}
      data-kt-menu-trigger='click'
    >
      <span className='menu-link'>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {fontIcon && (
          <span
            className='menu-icon'
            id={tutorial[title] ? 'sidebar-' + tutorial[title] : undefined}
          >
            <i className={clsx('bi', fontIcon)}></i>
          </span>
        )}
        <span className='menu-title'>{title}</span>
        {badge}
        <span className='menu-arrow'></span>
      </span>
      <div className={clsx('menu-sub menu-sub-accordion', {'menu-active-bg': isActive})}>
        {children}
      </div>
    </div>
  )
}

export {SidebarMenuItemWithSub}
